import { Box, Flex, Image, Text } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';
import SearchBar from 'ui/snippets/searchBar/SearchBar';

const HeroBanner = () => {
  const { t } = useI18n();

  return (
    <Flex
      w="100%"
      position="relative"
      overflow="hidden"
      bg="#000000"
      minH={{ base: '220px', lg: '280px' }}
      px={{ base: 4, lg: '80px' }}
      pt={{ base: 8, lg: '16px' }}
      pb={{ base: 8, lg: '60px' }}
      justifyContent="center"
      alignItems="center"
    >
      <Image
        src="/static/homepage/hero-abstract-left.svg"
        alt=""
        position="absolute"
        left={{ base: '-64px', lg: '-43px' }}
        top={{ base: '76px', lg: '48px' }}
        w={{ base: '280px', lg: '474px' }}
        h={{ base: '153px', lg: '258px' }}
        pointerEvents="none"
        userSelect="none"
      />
      <Image
        src="/static/homepage/hero-abstract-right.svg"
        alt=""
        position="absolute"
        right={{ base: '-92px', lg: '-60px' }}
        top={{ base: '-54px', lg: '-78px' }}
        w={{ base: '360px', lg: '569px' }}
        h={{ base: '196px', lg: '310px' }}
        pointerEvents="none"
        userSelect="none"
      />
      <Flex
        position="relative"
        direction="column"
        alignItems="center"
        gap={{ base: '24px', lg: '32px' }}
        w="100%"
      >
        <Flex alignItems="center" justifyContent="center" wrap="wrap">
          <Text
            as="span"
            color="#14DCAC"
            fontFamily="'Space Grotesk', var(--chakra-fonts-heading)"
            fontSize={{ base: '28px', lg: '32px' }}
            fontWeight={ 700 }
            lineHeight="1.25"
            letterSpacing="0.02em"
          >
            BOT
          </Text>
          <Text
            as="span"
            color="white"
            fontFamily="'Space Grotesk', var(--chakra-fonts-heading)"
            fontSize={{ base: '28px', lg: '32px' }}
            fontWeight={ 500 }
            lineHeight="1.25"
            letterSpacing="0.02em"
            ml={ 1 }
          >
            { t('home.chainExplorer') }
          </Text>
        </Flex>
        <Box w={{ base: '100%', lg: '800px' }} maxW="100%">
          <SearchBar isHomepage/>
        </Box>
      </Flex>
    </Flex>
  );
};

export default React.memo(HeroBanner);
